// extracted by mini-css-extract-plugin
module.exports = {"traitList":"NounTraitsOverlay_traitList__2ElTL"};